export class BooleanHelper {
    static getMappedNameFromValue(value: boolean, map: Map<boolean, string>): string | null {
        const name = map.get(value);
        if(name === undefined)
            return value as any;
        return name;
    }
}